<script>
    import { onMount } from "svelte";

    onMount(() => {});
</script>

<main>
    <div class="sliderWrapper">
        <div class="loginBtn">
            <button class="ui  basic blue button">
                <i class="user icon" /> Login
            </button>

            <div class="spacer" />
        </div>
        <div class="logoBar">
            <img
                src="../assets/images/logo.jpg"
                alt="logo"
                height="100%"
                width="100%"
            />
        </div>

        <div class="tagline">CLASS - STYLE - TASTE</div>
        <div class="punchline">
            All Drink Deliveries, <br /> Straight to Your Door.
        </div>

        <div class="ofAge">
            ✓ I’m 18+ years of age and agree to the <a href="terms"
                >terms of service</a
            >.
        </div>

        <div class="shopBtn">
            <button class="ui brown button" style="border-radius: 1px;">
                <i class="shopping cart icon" /> Shop
            </button>
        </div>
    </div>
</main>

<style>
    main {
        background-color: rgba(255, 0, 0, 0);
    }

    .sliderWrapper {
        min-height: 75vh;
        background-image: url("../assets/images/slider-2.webp");
        background-size: cover;
        background-repeat: no-repeat;
        background-position: left;
    }

    .spacer {
        height: 3em;
    }
    .logoBar {
        width: 8em;
        height: 8em;
        /* background: yellow; */
        margin: auto;
        border-radius: 50%;
        overflow: hidden;
    }

    .tagline {
        padding-top: 2em;
    }

    .punchline {
        margin: auto;
        max-width: 30em;
        font-family: "PT Serif", serif;
        font-size: 25px;
        font-weight: 900;
        color: rgb(34, 34, 34);
    }

    .ofAge {
        font-size: 12px;
        font-weight: 400;
        padding-top: 2em;
    }

    .ofAge a {
        color: brown;
    }

    .shopBtn {
        padding-top: 1em;
    }

    .loginBtn {
        text-align: right;
    }
    /* .slide-content {
        display: none;
    } */

    @media only screen and (min-width: 600px) {
        .sliderWrapper {
            min-height: 90vh;
        }

        .sliderWrapper {
            height: 75vh;
            background-image: url("../assets/images/slider-3.webp");
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
        }

        .punchline {
            margin: auto;
            max-width: 30em;
            font-family: "PT Serif", serif;
            font-size: 40px;
            font-weight: 600;
            line-height: 50px;
            padding-top: 0.1em;
        }
    }
</style>
